import { Link } from "react-router-dom";
import { Linkedin, Twitter, Instagram, Facebook, Mail, Phone, MapPin, Globe, Download } from "lucide-react";
import { Container } from "./Ui";
import { Logo } from "./Header";
import { CONTACT, SERVICES } from "../../data/content";

const ICONS = { LinkedIn: Linkedin, "X (Twitter)": Twitter, Instagram, Facebook };

const Col = ({ title, links }) => (
  <div>
    <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-[#8EC0FF]">{title}</h3>
    <ul className="mt-5 space-y-3">
      {links.map(([label, to]) => (
        <li key={label}><Link to={to} className="text-sm text-slate-300 transition-colors hover:text-white">{label}</Link></li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A1E3A] text-white">
    <Container className="py-16 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" className="inline-block rounded-xl bg-white px-4 py-3" aria-label="AppTarget home"><Logo className="h-9" /></Link>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">
            AppTarget Advertising Pvt. Ltd. is an affiliate and performance marketing company connecting advertisers with quality traffic partners.
          </p>
          <a href="https://www.apptarget.ai" data-testid="footer-website-link" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-[#8EC0FF]">
            <Globe className="h-4 w-4" /> {CONTACT.website}
          </a>
          <div className="mt-6 flex gap-2">
            {CONTACT.socials.map((s) => {
              const I = ICONS[s.name];
              return (
                <a key={s.name} href={s.href} {...(s.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer", "aria-label": `AppTarget on ${s.name}` } : { "aria-label": `${s.name} (link coming soon)` })} data-testid={`footer-social-${s.name.split(" ")[0].toLowerCase()}`}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-colors hover:border-[#2878E5] hover:bg-[#2878E5] hover:text-white">
                  <I className="h-4 w-4" />
                </a>
              );
            })}
            <a href={CONTACT.appDownload} target="_blank" rel="noopener noreferrer" data-testid="footer-app-download-btn"
              className="ml-1 inline-flex h-10 items-center gap-2 rounded-full bg-[#2878E5] px-4 text-sm font-semibold text-white transition-colors hover:bg-[#1f68cc]">
              <Download className="h-4 w-4" />Download App
            </a>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-8">
          <Col title="Company" links={[["About Us", "/about"], ["Solutions", "/solutions"], ["Verticals", "/verticals"], ["Contact Us", "/contact"]]} />
          <Col title="Partners" links={[["Advertisers", "/advertisers"], ["Publishers & Traffic Partners", "/publishers"], ...SERVICES.slice(0, 3).map((s) => [s.title, `/solutions#${s.slug}`])]} />
          <div className="col-span-2 sm:col-span-1">
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-[#8EC0FF]">Contact</h3>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              {CONTACT.emails.map((e) => (
                <li key={e} className="flex gap-2.5"><Mail className="mt-0.5 h-4 w-4 shrink-0" /><a href={`mailto:${e}`} data-testid={`footer-email-${e.split("@")[0]}`} className="break-all hover:text-white">{e}</a></li>
              ))}
              {CONTACT.phones.map((p) => (
                <li key={p} className="flex gap-2.5"><Phone className="mt-0.5 h-4 w-4 shrink-0" /><a href={`tel:${p}`} data-testid={`footer-phone-${p}`} className="hover:text-white">{p}</a></li>
              ))}
              {CONTACT.offices.map((o) => (
                <li key={o.label} className="flex gap-2.5"><MapPin className="mt-0.5 h-4 w-4 shrink-0" /><span><span className="block font-semibold text-white">{o.label}</span>{o.value}</span></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-slate-400 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} AppTarget Advertising Pvt. Ltd. All rights reserved.</p>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-white">Terms & Conditions</Link>
          <Link to="/cookie-policy" data-testid="footer-cookies" className="hover:text-white">Cookie Policy</Link>
          <Link to="/admin" data-testid="footer-admin" className="hover:text-white">Admin</Link>
        </div>
      </div>
    </Container>
  </footer>
);
